import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@knockrentals/knock-shared-web-v2';

const PropertyColumnText = ({ activeCount = 0, propertyName }) => (
  <Typography variant="body2">
    {propertyName}
    <br />
    <Typography component="span" variant="caption" color="secondary">
      {activeCount} active
    </Typography>
  </Typography>
);

PropertyColumnText.propTypes = {
  activeCount: PropTypes.number,
  propertyName: PropTypes.string,
};

export default PropertyColumnText;
